module.exports = __webpack_public_path__ + "static/media/Logo-footer-mobile-Bnp-Cardif.e005893c.svg";